var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvoryCoast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4154_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 24.4785C13.9679 24.4785 15.3741 24.2145 16.674 23.7321L17.1958 12.4785L16.674 1.22491C15.3741 0.742563 13.9679 0.478516 12.5001 0.478516C11.0323 0.478516 9.62615 0.742563 8.32621 1.22491L7.80444 12.4785L8.32616 23.7321C9.62615 24.2145 11.0323 24.4785 12.5001 24.4785Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.4785C0.5 17.638 3.7565 22.0366 8.32611 23.7321V1.22485C3.7565 2.92037 0.5 7.31888 0.5 12.4785Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6738 1.22485V23.7321C21.2434 22.0366 24.4999 17.638 24.4999 12.4785C24.4999 7.31888 21.2434 2.92037 16.6738 1.22485Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4154_1718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvoryCoast);
export default __webpack_public_path__ + "static/media/ivory-coast.9bdd8bd29d6cb05ab270c77690587558.svg";
export { ForwardRef as ReactComponent };